import { createFileRoute } from "@tanstack/react-router"
import NoosCapacityPlanningTab from "~/components/noos-supply-plan/NoosCapacityPlanningTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/capacity-planning",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("NOOS Supply Plan Detail - Capacity Planning")
  return <NoosCapacityPlanningTab />
}
